import { StarIcon } from '@heroicons/react/24/solid';
import { Badge } from './Badge';
import { useAppDispatch } from '../../../store';
import { uiActions } from '../slice';

export const UpgradeToPremiumBadge = () => {

  const dispatch = useAppDispatch();

  const showAccountModal = () => dispatch(uiActions.setCurrentModal({ modal: 'account' }));

  return (
    <Badge
      className='bg-yellow-100 text-yellow-700 ring-yellow-600/20 cursor-pointer hover:bg-yellow-200'
      onClick={showAccountModal}
    >
      <StarIcon className='size-3 mr-2' />
      Upgrade
    </Badge>
  );
};
